import axiosInstance from '../config/axios';

export const getNotificationsApi = (page = 0, limit = 15) =>
  axiosInstance.get(`/notifications?page=${page}&limit=${limit}`).then((res) => res.data);

/**
 * Mark a specific notification as read
 * @param {string} id
 */
export const markNotificationAsReadApi = (id) =>
  axiosInstance.patch(`/notifications/${id}/read`, {}).then((res) => res.data);

/**
 * Mark all notifications as read for the current user
 */
export const markAllNotificationsAsReadApi = () =>
  axiosInstance.patch('/notifications/read-all', {}).then((res) => res.data);
